import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import PageServices from "../../services/PageServices";

function SellingStockIndex() {
  const [rows, setRows] = useState([]);
  const [date, setDate] = useState(() => new Date().toISOString().split("T")[0]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!date) return;
    setLoading(true);
    PageServices.getOptionSellingStocks(date)
      .then((response) => {
        setRows(response?.data || []);
      })
      .catch((err) => {
        console.error(err);
        setRows([]);
      })
      .finally(() => setLoading(false));
  }, [date]);

  const filtered = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter(
      (r) =>
        String(r.symbol || "").toLowerCase().includes(q) ||
        String(r.productId || "").toLowerCase().includes(q)
    );
  }, [rows, searchQuery]);

  const formatDate = (isoDate) => {
    const dt = new Date(isoDate);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return dt.toLocaleDateString("en-GB", options).replace(/ /g, "-");
  };

  const getFormattedTime24 = (timestamp) => {
    const dt = new Date(new Date(timestamp).getTime() - 5.5 * 60 * 60 * 1000);
    return dt.toTimeString().slice(0, 5);
  };

  return (
    <section className="sr-stocks-section py-70">
      <div className="container-fluid">
        <div className="row justify-content-between align-items-center mb-3 px-2">
          <div className="col-auto">
            <Link to="/strong-sr-stock" className="btn btn-outline-secondary btn-sm">
              ← Strong S/R Stock
            </Link>
          </div>
          <div className="col-auto">
            <h4 className="mb-0 text-center text-dark fw-semibold">Selling Stock / Index</h4>
            <p
              className="small mb-0 text-center px-2"
              style={{ color: "#1e293b", maxWidth: "36rem", margin: "0 auto" }}
            >
              Symbols with at least one strike where CE and PE each have ≥2 of (OI, OI chg, vol) at
              chain max
            </p>
          </div>
          <div className="col-auto">
            <input
              className="form-control"
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
        </div>

        <div className="searchForm text-center mb-3">
          <div
            className="d-inline-flex align-items-center border rounded px-2 py-1 bg-white shadow-sm"
            style={{ borderColor: "#cbd5e1" }}
          >
            <i className="fa fa-search text-dark" aria-hidden />
            <input
              type="text"
              placeholder="Filter symbol…"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="border-0 outline-0 ms-2 text-dark bg-transparent"
              style={{ fontSize: "16px", width: "220px" }}
            />
          </div>
        </div>

        {loading ? (
          <p className="text-center text-dark fw-medium">Loading…</p>
        ) : filtered.length === 0 ? (
          <p className="text-center text-dark fw-medium">No option-selling signals for this date.</p>
        ) : (
          <div className="px-2 pb-4">
            <div className="row g-3">
              {filtered.map((item, gi) => {
                const label = item.symbol || item.productId;
                const timeLabel = item.parentTimestamp
                  ? new Date(
                      new Date(item.parentTimestamp).getTime() - 5.5 * 60 * 60 * 1000
                    ).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })
                  : "";
                return (
                  <div key={item.productId || gi} className="col-6 col-md-3">
                    <div
                      className="h-100 rounded-3 border bg-white d-flex flex-column p-3 shadow-sm"
                      style={{
                        borderColor: "#cbd5e1",
                        minHeight: "148px",
                        boxShadow: "0 1px 3px rgba(15, 23, 42, 0.08)",
                      }}
                    >
                      <div
                        className="fw-bold text-truncate mb-1"
                        style={{ color: "#0f172a", fontSize: "1rem", letterSpacing: "-0.02em" }}
                        title={String(label)}
                      >
                        {label}
                      </div>
                      <div className="small mb-auto" style={{ color: "#475569" }}>
                        {timeLabel ? `Snapshot · ${timeLabel}` : "—"}
                      </div>
                      <div className="d-flex flex-column flex-sm-row gap-2 mt-3">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-primary flex-fill fw-semibold"
                          style={{ borderWidth: "2px" }}
                          onClick={() => {
                            const dateStr = formatDate(item.parentTimestamp);
                            const timeStr = getFormattedTime24(item.parentTimestamp);
                            const symbolToken = item.productId;
                            localStorage.setItem("stock", symbolToken);
                            window.open(
                              `/backtester?date=${dateStr}&time=${timeStr}&symbolToken=${symbolToken}`,
                              "_blank"
                            );
                          }}
                        >
                          Historical
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-primary flex-fill fw-semibold"
                          onClick={() => {
                            localStorage.setItem("stock", item.productId);
                            window.open("/optionchain", "_blank");
                          }}
                        >
                          Live Data
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default SellingStockIndex;
